export enum ShareAccessType {
	public = 'public',
	password = 'password',
}
